export default "__VITE_ASSET__Cnfn_Mz2__"